import { render, staticRenderFns } from "./FirestopMarkingIcon.vue?vue&type=template&id=9a040054&scoped=true"
import script from "./FirestopMarkingIcon.vue?vue&type=script&lang=js"
export * from "./FirestopMarkingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a040054",
  null
  
)

export default component.exports